import { render, staticRenderFns } from "./company-number.vue?vue&type=template&id=0d7201f0&"
import script from "./company-number.vue?vue&type=script&lang=js&"
export * from "./company-number.vue?vue&type=script&lang=js&"
import style0 from "./company-number.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports